export default "__VITE_ASSET__Bl89yv2k__"